import { getModules } from "../../sdk/modules/modules";
import { useQuery } from "react-query";
import EditRoleModal from "./EditRoleModal";

const ReviewEditRole = ({
  closeRoleModal,
  activeIndex,
  handleNextStep,
  finishText,
  loading,
  myRole,
}) => {
  const { data: allModules } = useQuery({
    queryKey: ["modules"],
    queryFn: () => getModules(),
    initialData: [],
  });
  return (
    <EditRoleModal
      closeRoleModal={closeRoleModal}
      activeIndex={activeIndex}
      handleNextStep={handleNextStep}
      finishText={finishText}
      loading={loading}
    >
      <div>
        <p className="font-medium text-[15px] text-[#222222]">
          Create a new role
        </p>
        <p className="text-[#000000] font-semibold text-[20px]">Finish</p>
        <p className="text-[#5C5C5C] text-[14px] font-normal">
          Great work! You've provided all the necessary details for the new
          user. Take a moment to review and confirm the settings below:
        </p>
        <div className="flex items-start my-[15px] w-full">
          <div className="w-[30%]">
            <p className="text-[#000000] text-[14px] font-medium">Role Name</p>
            <p className="text-[#5C5C5C] text-[15px] font-normal">
              {myRole?.roleName ?? ""}
            </p>
            <p className="text-[#00A676] text-[15px] font-normal">Edit</p>
          </div>
          <div className="w-[70%]">
            <p className="text-[#000000] text-[14px] font-medium">
              Role Description
            </p>
            <p className="text-[#5C5C5C] text-[15px] font-normal">
              {myRole?.roleDescription ?? ""}
            </p>
            <p className="text-[#00A676] text-[15px] font-normal">Edit</p>
          </div>
        </div>
        <div className="w-full border p-[10px] border-[#A8A8A8] my-[20px] h-[220px] rounded-[5px] bg-white overflow-y-auto">
          {allModules &&
            allModules.map((module) => (
              <div>
                <p
                  key={module.id}
                  className="text-[#000000] mb-[15px] font-bold text-[16px]"
                >
                  {module?.name}
                </p>
                {module?.permissions?.map((permission) => (
                  <div
                    key={permission?.id}
                    className="flex items-center mb-[15px] pl-[20px] justify-between"
                  >
                    <p className="text-[#000000] font-normal text-[14px]">
                      {permission?.name}
                    </p>
                    <input
                      type="checkbox"
                      name="accounts"
                      id="accounts"
                      checked={myRole?.permissions?.includes(permission?.id)}
                    />
                  </div>
                ))}
              </div>
            ))}
        </div>
      </div>
    </EditRoleModal>
  );
};

export default ReviewEditRole;
